import axios from 'axios'
import { deepFreeze } from '../../../features/common/Utilities'
import { DATAMASTER_ENDPOINT } from 'common/endpoints'

export async function getPaginatedListDatamaster({ search, cancelToken }) {
  const results = await axios
    .get(`${DATAMASTER_ENDPOINT}/${search.replace('fields=', 'fields=id,')}`, {
      cancelToken
    })
    .then(res => res.data)
    .then(paginatedList => {
      paginatedList.data.forEach(row => {
        row.breadCrumbLabel = `${row.brand} ${row.model} ${row.version}`
      })
      return paginatedList
    })

  return deepFreeze(results)
}
